/* Buy page step 2 > Next: fires Meta AddPaymentInfo (standard, usable as a Sales conversion event) and the custom ReceiptSubmitted. */
(function () {
  if (window.__wiRcpt) return;
  window.__wiRcpt = true;
  var PIXEL = '2172055056999016';
  function ensure() {
    if (window.fbq) return;
    !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', PIXEL);
  }
  function wrap() {
    var A = window.Shopify && Shopify.analytics;
    if (!A || !A.publish) return false;
    if (A.__wiWrapped) return true;
    var orig = A.publish;
    A.publish = function (name, data) {
      try {
        if (name === 'weddinginvites:receipt_added') {
          ensure();
          var x = data || {}, id = 'rcpt-' + (x.order_ref || Date.now());
          var p = { content_name: x.content_name, content_type: 'product', payment_method: x.payment_method, value: 3000, currency: 'PKR' };
          fbq('track', 'AddPaymentInfo', p, { eventID: id + '-api' });
          fbq('trackCustom', 'ReceiptSubmitted', p, { eventID: id });
          if (window.console) console.log('WI direct pixel sent AddPaymentInfo + ReceiptSubmitted');
        }
      } catch (e) {}
      return orig.apply(this, arguments);
    };
    A.__wiWrapped = true;
    return true;
  }
  if (!wrap()) { var n = 0, t = setInterval(function () { if (wrap() || ++n > 40) clearInterval(t); }, 250); }
})();
